import { Action } from 'redux';

import { ScheduleSingleFlowTask } from '~src/app/actions/AppActionTypes';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { ISpaceItemDetailInfo } from '~src/ts/models/ISpaceItemDetailInfo';

export interface ScheduleSingleFlowTaskReduxAction extends Action {
  readonly flow: IContentInfo;
}

export function scheduleSingleFlowTaskAction(flow: IContentInfo | ISpaceItemDetailInfo<'flow'>): ScheduleSingleFlowTaskReduxAction {
  return {
    type: ScheduleSingleFlowTask,
    flow
  };
}
